import { useQuery } from 'data-fetching-client';
import { GET_NAME_FOR_IMPORT_ID } from 'flow-doctor-lib/queries/CrmObjectQueries';
const useImportNameById = ({
  portalId,
  importId
}, {
  skip
} = {}) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_NAME_FOR_IMPORT_ID, {
    variables: {
      portalId,
      importId
    },
    skip
  });
  const dataToReturn = data ? data.nameForImportId.hits[importId] : null;
  return {
    data: dataToReturn,
    loading,
    error
  };
};
export default useImportNameById;